/**
 * Country / market change — invisible native <select> over Change.
 * Selecting a country submits the localization form.
 */
(function () {
  if (window.__peggellLocationChangeBound) return;
  window.__peggellLocationChangeBound = true;

  function onChange(event) {
    const select = event.target.closest('[data-peggell-location-select]');
    if (!select) return;

    const form = select.closest('form');
    if (form) form.submit();
  }

  document.addEventListener('change', onChange);
})();
